import { ClientQueryParams } from "twitch-ext";

const urlParams = new URLSearchParams(window.location.search);
const extensionQueryParams: ClientQueryParams = {
  anchor: urlParams.get("anchor"),
  language: urlParams.get("language"),
  locale: urlParams.get("locale"),
  mode: urlParams.get("mode"),
  platform: urlParams.get("platform"),
  popout: urlParams.get("popout"),
  state: urlParams.get("state"),
} as ClientQueryParams;

export default extensionQueryParams;
